import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import styled from "styled-components";

import { PATH_HOME, PATH_PROFILE, enumLanguage } from "@configs";
import { IMerchant } from "@interfaces";
import { selectApp, selectAuth, selectMerchant } from "@redux";
import UserStore from "@Rocket-Innovation/components/store/UserStore";
import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import { create } from "zustand";

interface MenuState {
    merchant: IMerchant | null;
    // setMerchant: (merchant: IMerchant) => void;
}

export const useMerchantStore = create<MenuState>()((set) => ({
    merchant: null,
    // setMerchant: (merchant) => set((state) => ({ merchant })),
}));

export const ComponentMenuBar = () => {
    //page hook
    const { t } = useTranslation();
    //push route
    const history = useHistory();
    //redux statex
    const { auth, userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    const merchantRedux = useSelector(selectMerchant);
    const i18nextLng = window.localStorage.i18nextLng;
    const { pathname } = useLocation();
    const [isLoading, setIsloading] = useState(false);
    const { lang } = useSelector(selectApp);

    const handleClickBottomMenu = (path: string) => {
        const token = UserStore.getState().accessToken ?? auth?.accessToken;

        if (path[0] === "/") {
            history.push(path);
        } else if (path.includes("service-client")) {
            if (path.includes("mybooking")) {
                let outUrl = path.split("mybooking")[0];
                window.open(
                    `${outUrl}auth/${token}?goto=mybooking&lang=${lang === "THAI" ? "th" : "en"}`,
                    "_self"
                );
            } else {
                window.open(`${path}auth/${token}?lang=${lang === "THAI" ? "th" : "en"}`, "_self");
            }
        } else if (path.includes("pos-client")) {
            window.open(`${path}auth/${token}?lang=${lang === "THAI" ? "th" : "en"}`, "_self");
        } else if (
            path.includes("rocket-ecommerce") ||
            path.includes("fudidiworld") ||
            path.includes("drpongskinclub")
        ) {
            let originUrl = new URL(path).origin;
            let pathName = new URL(path).pathname;
            window.open(
                `${originUrl}/auth/${token}?lang=${
                    lang === "THAI" ? "th" : "en"
                }&redirect=${pathName}`,
                "_self"
            );
        } else if (path.includes("rocket-booking") || path.includes("eventease")) {
            if (path.includes("mybooking")) {
                let outUrl = path.split("mybooking")[0];
                window.open(
                    `${outUrl}auth/${token}?redirect=mybooking&lang=${
                        lang === "THAI" ? "th" : "en"
                    }`,
                    "_self"
                );
            } else {
                let outUrl = path.split("/booking")[0];
                window.open(
                    `${outUrl}/auth/${token}?redirect=booking&lang=${
                        lang === "THAI" ? "th" : "en"
                    }`,
                    "_self"
                );
            }
        } else {
            window.open(path, "_self");
        }
    };

    useEffect(() => {
        setTimeout(() => {
            setIsloading(false);
        }, 1000);
    });

    const loadingComponent = (
        <StyledSkeleton>
            <div className="wrapper-skeleton">
                <div className="layout-skeleton">
                    <Skeleton
                        loading={true}
                        avatar
                        active
                        title={false}
                        paragraph={{ rows: 1, width: 55 }}
                    ></Skeleton>
                    <Skeleton
                        loading={true}
                        avatar
                        active
                        title={false}
                        paragraph={{ rows: 1, width: 55 }}
                    ></Skeleton>
                    <Skeleton
                        loading={true}
                        avatar
                        active
                        title={false}
                        paragraph={{ rows: 1, width: 55 }}
                    ></Skeleton>
                    <Skeleton
                        loading={true}
                        avatar
                        active
                        title={false}
                        paragraph={{ rows: 1, width: 55 }}
                    ></Skeleton>
                </div>
            </div>
        </StyledSkeleton>
    );

    useEffect(() => {
        if (merchantRedux) useMerchantStore.setState({ merchant: merchantRedux as IMerchant });
    }, [merchantRedux]);
    //Store stage
    const merchant = useMerchantStore.getState().merchant;

    return (
        <>
            {isLoading === false ? (
                <>
                    {userInfo?.contact?.sellerId === "" ||
                    userInfo?.contact?.sellerId === undefined ? (
                        <>
                            {merchant?.themes?.bottomBarMenu?.menuType?.isType1 ? (
                                <StyledMenuBar themeColor={themes?.themeColor!}>
                                    <div className="sub-bg"></div>
                                    <div className="main-menubar">
                                        {i18nextLng === enumLanguage.EN ||
                                        i18nextLng === enumLanguage.EN_GB ? (
                                            <>
                                                <div className="control-menubar">
                                                    <div
                                                        className="box-menubar"
                                                        onClick={() => history.push(PATH_HOME)}
                                                    >
                                                        {merchant?.themes?.bottomBarMenu?.iconType
                                                            .isImage ? (
                                                            <div className="img-menubar">
                                                                <img
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.bottomBarMenu
                                                                            ?.homeMenu
                                                                            ?.iconBottomName
                                                                    }
                                                                    alt=""
                                                                />
                                                            </div>
                                                        ) : null}
                                                        {merchant?.themes?.bottomBarMenu?.iconType
                                                            .isVector ? (
                                                            <StyleImgVector
                                                                color={
                                                                    merchant?.themes?.normalColor
                                                                }
                                                            >
                                                                <div className="img-menubar">
                                                                    <img
                                                                        src={
                                                                            merchant?.themes
                                                                                ?.bottomBarMenu
                                                                                ?.homeMenu
                                                                                ?.iconBottomName
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </StyleImgVector>
                                                        ) : null}
                                                        <span>
                                                            {merchant?.themes?.bottomBarMenu
                                                                ?.homeMenu?.bottomTitle || "Home"}
                                                        </span>
                                                    </div>
                                                    {merchant?.themes?.bottomBarMenu?.bottomBarName.map(
                                                        (item: any, index: any) => {
                                                            if (!item?.isUse) {
                                                                return null;
                                                            }
                                                            return (
                                                                <div
                                                                    className="box-menubar"
                                                                    key={index}
                                                                    onClick={() =>
                                                                        handleClickBottomMenu(
                                                                            item.bottomLink
                                                                        )
                                                                    }
                                                                >
                                                                    {merchant?.themes?.bottomBarMenu
                                                                        ?.iconType.isImage ? (
                                                                        <div className="img-menubar">
                                                                            <img
                                                                                src={
                                                                                    item.iconBottomName
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    ) : null}
                                                                    {merchant?.themes?.bottomBarMenu
                                                                        ?.iconType.isVector ? (
                                                                        <StyleImgVector
                                                                            color={
                                                                                merchant?.themes
                                                                                    ?.normalColor
                                                                            }
                                                                        >
                                                                            <div className="img-menubar">
                                                                                <img
                                                                                    src={
                                                                                        item.iconBottomName
                                                                                    }
                                                                                    alt=""
                                                                                />
                                                                            </div>
                                                                        </StyleImgVector>
                                                                    ) : null}
                                                                    <span>
                                                                        {item.bottomTitle || "Menu"}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                    <div
                                                        className="box-menubar"
                                                        onClick={() => history.push(PATH_PROFILE)}
                                                    >
                                                        <div className="img-menubar">
                                                            <img
                                                                src={
                                                                    merchant?.themes?.bottomBarMenu
                                                                        ?.profileMenu
                                                                        ?.iconBottomName
                                                                }
                                                                alt=""
                                                            />
                                                        </div>
                                                        <span>
                                                            {merchant?.themes?.bottomBarMenu
                                                                ?.profileMenu?.bottomTitle ||
                                                                "Profile"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="control-menubar">
                                                    <div
                                                        className="box-menubar"
                                                        onClick={() => history.push(PATH_HOME)}
                                                    >
                                                        {merchant?.themes?.bottomBarMenu?.iconType
                                                            .isImage ? (
                                                            <div className="img-menubar">
                                                                <img
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.bottomBarMenu
                                                                            ?.homeMenu
                                                                            ?.iconBottomName
                                                                    }
                                                                    alt=""
                                                                />
                                                            </div>
                                                        ) : null}
                                                        {merchant?.themes?.bottomBarMenu?.iconType
                                                            .isVector ? (
                                                            <StyleImgVector
                                                                color={
                                                                    merchant?.themes?.normalColor
                                                                }
                                                            >
                                                                <div className="img-menubar">
                                                                    <img
                                                                        src={
                                                                            merchant?.themes
                                                                                ?.bottomBarMenu
                                                                                ?.homeMenu
                                                                                ?.iconBottomName
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </StyleImgVector>
                                                        ) : null}
                                                        <span>
                                                            {merchant?.themes?.bottomBarMenu
                                                                ?.homeMenu?.bottomTitleTh ||
                                                                "หน้าแรก"}
                                                        </span>
                                                    </div>
                                                    {merchant?.themes?.bottomBarMenu?.bottomBarName.map(
                                                        (item: any, index: any) => {
                                                            if (!item?.isUse) {
                                                                return null;
                                                            }
                                                            return (
                                                                <div
                                                                    className="box-menubar"
                                                                    key={index}
                                                                    onClick={() =>
                                                                        handleClickBottomMenu(
                                                                            item.bottomLink
                                                                        )
                                                                    }
                                                                >
                                                                    {merchant?.themes?.bottomBarMenu
                                                                        ?.iconType.isImage ? (
                                                                        <div className="img-menubar">
                                                                            <img
                                                                                src={
                                                                                    item.iconBottomName
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    ) : null}
                                                                    {merchant?.themes?.bottomBarMenu
                                                                        ?.iconType.isVector ? (
                                                                        <StyleImgVector
                                                                            color={
                                                                                merchant?.themes
                                                                                    ?.normalColor
                                                                            }
                                                                        >
                                                                            <div className="img-menubar">
                                                                                <img
                                                                                    src={
                                                                                        item.iconBottomName
                                                                                    }
                                                                                    alt=""
                                                                                />
                                                                            </div>
                                                                        </StyleImgVector>
                                                                    ) : null}
                                                                    <span>
                                                                        {item.bottomTitleTh ||
                                                                            "เมนู"}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                    <div
                                                        className="box-menubar"
                                                        onClick={() => history.push(PATH_PROFILE)}
                                                    >
                                                        {merchant?.themes?.bottomBarMenu?.iconType
                                                            .isImage ? (
                                                            <div className="img-menubar">
                                                                <img
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.bottomBarMenu
                                                                            ?.profileMenu
                                                                            ?.iconBottomName
                                                                    }
                                                                    alt=""
                                                                />
                                                            </div>
                                                        ) : null}
                                                        {merchant?.themes?.bottomBarMenu?.iconType
                                                            .isVector ? (
                                                            <StyleImgVector
                                                                color={
                                                                    merchant?.themes?.normalColor
                                                                }
                                                            >
                                                                <div className="img-menubar">
                                                                    <img
                                                                        src={
                                                                            merchant?.themes
                                                                                ?.bottomBarMenu
                                                                                ?.profileMenu
                                                                                ?.iconBottomName
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </StyleImgVector>
                                                        ) : null}
                                                        <span>
                                                            {merchant?.themes?.bottomBarMenu
                                                                ?.profileMenu?.bottomTitleTh ||
                                                                "โปรไฟล์"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </StyledMenuBar>
                            ) : null}
                            {merchant?.themes?.bottomBarMenu?.menuType?.isType2 ? (
                                <StyledMenuBarType2
                                    themeColor={themes?.themeColor!}
                                    color={merchant?.themes?.bottomBarMenu?.normalColor}
                                >
                                    <StyledSubMenu
                                        color={merchant?.themes?.bottomBarMenu?.clickColor}
                                    >
                                        <div className="sub-bg"></div>
                                        <div className="main-menubar">
                                            {i18nextLng === enumLanguage.EN ||
                                            i18nextLng === enumLanguage.EN_GB ? (
                                                <>
                                                    <div className="control-menubar">
                                                        <StyledImgType2
                                                            img={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.homeMenu?.iconBottomName
                                                            }
                                                            clickicon={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.homeMenu
                                                                    ?.iconClickStateBottomName
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    "box-menubar " +
                                                                    (pathname === PATH_HOME
                                                                        ? "active"
                                                                        : "")
                                                                }
                                                                onClick={() =>
                                                                    history.push(PATH_HOME)
                                                                }
                                                            >
                                                                {merchant?.themes?.bottomBarMenu
                                                                    ?.iconType.isImage ? (
                                                                    <div
                                                                        className={"showimgtype2"}
                                                                    ></div>
                                                                ) : null}
                                                                {merchant?.themes?.bottomBarMenu
                                                                    ?.iconType.isVector ? (
                                                                    <div
                                                                        className={"showimgtype2"}
                                                                    ></div>
                                                                ) : null}
                                                                <span>
                                                                    {merchant?.themes?.bottomBarMenu
                                                                        ?.homeMenu?.bottomTitle ||
                                                                        "Home"}
                                                                </span>
                                                            </div>
                                                        </StyledImgType2>
                                                        {merchant?.themes?.bottomBarMenu?.bottomBarName.map(
                                                            (item: any, index: any) => {
                                                                if (!item?.isUse) {
                                                                    return null;
                                                                }
                                                                return (
                                                                    <StyledImgType2
                                                                        img={item.iconBottomName}
                                                                        clickicon={
                                                                            item.iconClickStateBottomName
                                                                        }
                                                                        key={index}
                                                                    >
                                                                        <div
                                                                            className={
                                                                                "box-menubar " +
                                                                                (pathname ===
                                                                                item.bottomLink
                                                                                    ? "active"
                                                                                    : "")
                                                                            }
                                                                            key={index}
                                                                            onClick={() =>
                                                                                handleClickBottomMenu(
                                                                                    item.bottomLink
                                                                                )
                                                                            }
                                                                        >
                                                                            {merchant?.themes
                                                                                ?.bottomBarMenu
                                                                                ?.iconType
                                                                                .isImage ? (
                                                                                <div
                                                                                    className={
                                                                                        "showimgtype2"
                                                                                    }
                                                                                ></div>
                                                                            ) : null}
                                                                            {merchant?.themes
                                                                                ?.bottomBarMenu
                                                                                ?.iconType
                                                                                .isVector ? (
                                                                                <div
                                                                                    className={
                                                                                        "showimgtype2"
                                                                                    }
                                                                                ></div>
                                                                            ) : null}
                                                                            <span>
                                                                                {item.bottomTitle ||
                                                                                    "Menu"}
                                                                            </span>
                                                                        </div>
                                                                    </StyledImgType2>
                                                                );
                                                            }
                                                        )}
                                                        <StyledImgType2
                                                            img={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.profileMenu?.iconBottomName
                                                            }
                                                            clickicon={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.profileMenu
                                                                    ?.iconClickStateBottomName
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    "box-menubar " +
                                                                    (pathname === PATH_PROFILE
                                                                        ? "active"
                                                                        : "")
                                                                }
                                                                onClick={() =>
                                                                    history.push(PATH_PROFILE)
                                                                }
                                                            >
                                                                <div
                                                                    className={"showimgtype2"}
                                                                ></div>
                                                                <span>
                                                                    {merchant?.themes?.bottomBarMenu
                                                                        ?.profileMenu
                                                                        ?.bottomTitle || "Profile"}
                                                                </span>
                                                            </div>
                                                        </StyledImgType2>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="control-menubar">
                                                        <StyledImgType2
                                                            img={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.homeMenu?.iconBottomName
                                                            }
                                                            clickicon={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.homeMenu
                                                                    ?.iconClickStateBottomName
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    "box-menubar " +
                                                                    (pathname === PATH_HOME
                                                                        ? "active"
                                                                        : "")
                                                                }
                                                                onClick={() =>
                                                                    history.push(PATH_HOME)
                                                                }
                                                            >
                                                                {merchant?.themes?.bottomBarMenu
                                                                    ?.iconType.isImage ? (
                                                                    <div
                                                                        className={"showimgtype2"}
                                                                    ></div>
                                                                ) : null}
                                                                {merchant?.themes?.bottomBarMenu
                                                                    ?.iconType.isVector ? (
                                                                    <StyleImgVector
                                                                        color={
                                                                            merchant?.themes
                                                                                ?.normalColor
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={
                                                                                "showimgtype2"
                                                                            }
                                                                        ></div>
                                                                    </StyleImgVector>
                                                                ) : null}
                                                                <span>
                                                                    {merchant?.themes?.bottomBarMenu
                                                                        ?.homeMenu?.bottomTitleTh ||
                                                                        "หน้าแรก"}
                                                                </span>
                                                            </div>
                                                        </StyledImgType2>
                                                        {merchant?.themes?.bottomBarMenu?.bottomBarName.map(
                                                            (item: any, index: any) => {
                                                                if (!item?.isUse) {
                                                                    return null;
                                                                }
                                                                return (
                                                                    <StyledImgType2
                                                                        key={index}
                                                                        img={item.iconBottomName}
                                                                        clickicon={
                                                                            item.iconClickStateBottomName
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={
                                                                                "box-menubar " +
                                                                                (pathname ===
                                                                                item.bottomLink
                                                                                    ? "active"
                                                                                    : "")
                                                                            }
                                                                            onClick={() =>
                                                                                handleClickBottomMenu(
                                                                                    item.bottomLink
                                                                                )
                                                                            }
                                                                        >
                                                                            {merchant?.themes
                                                                                ?.bottomBarMenu
                                                                                ?.iconType
                                                                                .isImage ? (
                                                                                <div
                                                                                    className={
                                                                                        "showimgtype2"
                                                                                    }
                                                                                ></div>
                                                                            ) : null}
                                                                            {merchant?.themes
                                                                                ?.bottomBarMenu
                                                                                ?.iconType
                                                                                .isVector ? (
                                                                                <StyleImgVector
                                                                                    color={
                                                                                        merchant
                                                                                            ?.themes
                                                                                            ?.normalColor
                                                                                    }
                                                                                >
                                                                                    <div
                                                                                        className={
                                                                                            "showimgtype2"
                                                                                        }
                                                                                    ></div>
                                                                                </StyleImgVector>
                                                                            ) : null}
                                                                            <span>
                                                                                {item.bottomTitleTh ||
                                                                                    "เมนู"}
                                                                            </span>
                                                                        </div>
                                                                    </StyledImgType2>
                                                                );
                                                            }
                                                        )}
                                                        <StyledImgType2
                                                            img={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.profileMenu?.iconBottomName
                                                            }
                                                            clickicon={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.profileMenu
                                                                    ?.iconClickStateBottomName
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    "box-menubar " +
                                                                    (pathname === PATH_PROFILE
                                                                        ? "active"
                                                                        : "")
                                                                }
                                                                onClick={() =>
                                                                    history.push(PATH_PROFILE)
                                                                }
                                                            >
                                                                {merchant?.themes?.bottomBarMenu
                                                                    ?.iconType.isImage ? (
                                                                    <div
                                                                        className={"showimgtype2"}
                                                                    ></div>
                                                                ) : null}
                                                                {merchant?.themes?.bottomBarMenu
                                                                    ?.iconType.isVector ? (
                                                                    <StyleImgVector
                                                                        color={
                                                                            merchant?.themes
                                                                                ?.normalColor
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={
                                                                                "showimgtype2"
                                                                            }
                                                                        ></div>
                                                                    </StyleImgVector>
                                                                ) : null}
                                                                <span>
                                                                    {merchant?.themes?.bottomBarMenu
                                                                        ?.profileMenu
                                                                        ?.bottomTitleTh ||
                                                                        "โปรไฟล์"}
                                                                </span>
                                                            </div>
                                                        </StyledImgType2>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </StyledSubMenu>
                                </StyledMenuBarType2>
                            ) : null}
                            {merchant?.themes?.bottomBarMenu?.menuType?.isType3 ? (
                                <StyledMenuBarType3 themeColor={themes?.themeColor!}>
                                    <div className="sub-bg"></div>
                                    <div className="main-menubar">
                                        {i18nextLng === enumLanguage.EN ||
                                        i18nextLng === enumLanguage.EN_GB ? (
                                            <>
                                                <div className="control-menubar type3">
                                                    <div
                                                        className={
                                                            "box-menubar " +
                                                            (pathname === PATH_HOME ? "active" : "")
                                                        }
                                                        onClick={() => history.push(PATH_HOME)}
                                                    >
                                                        {merchant?.themes?.bottomBarMenu?.iconType
                                                            .isImage ? (
                                                            <div className="img-menubar">
                                                                <img
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.bottomBarMenu
                                                                            ?.homeMenu
                                                                            ?.iconBottomName
                                                                    }
                                                                    alt=""
                                                                />
                                                            </div>
                                                        ) : null}
                                                        {merchant?.themes?.bottomBarMenu?.iconType
                                                            .isVector ? (
                                                            <StyleImgVector
                                                                color={
                                                                    merchant?.themes?.normalColor
                                                                }
                                                            >
                                                                <div className="img-menubar">
                                                                    <img
                                                                        src={
                                                                            merchant?.themes
                                                                                ?.bottomBarMenu
                                                                                ?.homeMenu
                                                                                ?.iconBottomName
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </StyleImgVector>
                                                        ) : null}
                                                        <span>
                                                            {merchant?.themes?.bottomBarMenu
                                                                ?.homeMenu?.bottomTitle || "Home"}
                                                        </span>
                                                    </div>
                                                    {merchant?.themes?.bottomBarMenu?.bottomBarName.map(
                                                        (item: any, index: any) => {
                                                            if (!item?.isUse) {
                                                                return null;
                                                            }
                                                            return (
                                                                <div
                                                                    className={
                                                                        "box-menubar " +
                                                                        (pathname ===
                                                                        item.bottomLink
                                                                            ? "active"
                                                                            : "")
                                                                    }
                                                                    key={index}
                                                                    onClick={() =>
                                                                        handleClickBottomMenu(
                                                                            item.bottomLink
                                                                        )
                                                                    }
                                                                >
                                                                    {merchant?.themes?.bottomBarMenu
                                                                        ?.iconType.isImage ? (
                                                                        <div className="img-menubar">
                                                                            <img
                                                                                src={
                                                                                    item.iconBottomName
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    ) : null}
                                                                    {merchant?.themes?.bottomBarMenu
                                                                        ?.iconType.isVector ? (
                                                                        <StyleImgVector
                                                                            color={
                                                                                merchant?.themes
                                                                                    ?.normalColor
                                                                            }
                                                                        >
                                                                            <div className="img-menubar">
                                                                                <img
                                                                                    src={
                                                                                        item.iconBottomName
                                                                                    }
                                                                                    alt=""
                                                                                />
                                                                            </div>
                                                                        </StyleImgVector>
                                                                    ) : null}
                                                                    <span>
                                                                        {item.bottomTitle || "Menu"}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                    <div
                                                        className={
                                                            "box-menubar " +
                                                            (pathname === PATH_PROFILE
                                                                ? "active"
                                                                : "")
                                                        }
                                                        onClick={() => history.push(PATH_PROFILE)}
                                                    >
                                                        <div className="img-menubar">
                                                            <img
                                                                src={
                                                                    merchant?.themes?.bottomBarMenu
                                                                        ?.profileMenu
                                                                        ?.iconBottomName
                                                                }
                                                                alt=""
                                                            />
                                                        </div>
                                                        <span>
                                                            {merchant?.themes?.bottomBarMenu
                                                                ?.profileMenu?.bottomTitle ||
                                                                "Profile"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="control-menubar type3">
                                                    <div
                                                        className={
                                                            "box-menubar " +
                                                            (pathname === PATH_HOME ? "active" : "")
                                                        }
                                                        onClick={() => history.push(PATH_HOME)}
                                                    >
                                                        {merchant?.themes?.bottomBarMenu?.iconType
                                                            .isImage ? (
                                                            <div className="img-menubar">
                                                                <img
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.bottomBarMenu
                                                                            ?.homeMenu
                                                                            ?.iconBottomName
                                                                    }
                                                                    alt=""
                                                                />
                                                            </div>
                                                        ) : null}
                                                        {merchant?.themes?.bottomBarMenu?.iconType
                                                            .isVector ? (
                                                            <StyleImgVector
                                                                color={
                                                                    merchant?.themes?.normalColor
                                                                }
                                                            >
                                                                <div className="img-menubar">
                                                                    <img
                                                                        src={
                                                                            merchant?.themes
                                                                                ?.bottomBarMenu
                                                                                ?.homeMenu
                                                                                ?.iconBottomName
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </StyleImgVector>
                                                        ) : null}
                                                        <span>
                                                            {merchant?.themes?.bottomBarMenu
                                                                ?.homeMenu?.bottomTitleTh ||
                                                                "หน้าแรก"}
                                                        </span>
                                                    </div>
                                                    {merchant?.themes?.bottomBarMenu?.bottomBarName.map(
                                                        (item: any, index: any) => {
                                                            if (!item?.isUse) {
                                                                return null;
                                                            }
                                                            return (
                                                                <div
                                                                    className={
                                                                        "box-menubar " +
                                                                        (pathname ===
                                                                        item.bottomLink
                                                                            ? "active"
                                                                            : "")
                                                                    }
                                                                    key={index}
                                                                    onClick={() =>
                                                                        handleClickBottomMenu(
                                                                            item.bottomLink
                                                                        )
                                                                    }
                                                                >
                                                                    {merchant?.themes?.bottomBarMenu
                                                                        ?.iconType.isImage ? (
                                                                        <div className="img-menubar">
                                                                            <img
                                                                                src={
                                                                                    item.iconBottomName
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    ) : null}
                                                                    {merchant?.themes?.bottomBarMenu
                                                                        ?.iconType.isVector ? (
                                                                        <StyleImgVector
                                                                            color={
                                                                                merchant?.themes
                                                                                    ?.normalColor
                                                                            }
                                                                        >
                                                                            <div className="img-menubar">
                                                                                <img
                                                                                    src={
                                                                                        item.iconBottomName
                                                                                    }
                                                                                    alt=""
                                                                                />
                                                                            </div>
                                                                        </StyleImgVector>
                                                                    ) : null}
                                                                    <span>
                                                                        {item.bottomTitleTh ||
                                                                            "เมนู"}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                    <div
                                                        className={
                                                            "box-menubar " +
                                                            (pathname === PATH_PROFILE
                                                                ? "active"
                                                                : "")
                                                        }
                                                        onClick={() => history.push(PATH_PROFILE)}
                                                    >
                                                        {merchant?.themes?.bottomBarMenu?.iconType
                                                            .isImage ? (
                                                            <div className="img-menubar">
                                                                <img
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.bottomBarMenu
                                                                            ?.profileMenu
                                                                            ?.iconBottomName
                                                                    }
                                                                    alt=""
                                                                />
                                                            </div>
                                                        ) : null}
                                                        {merchant?.themes?.bottomBarMenu?.iconType
                                                            .isVector ? (
                                                            <StyleImgVector
                                                                color={
                                                                    merchant?.themes?.normalColor
                                                                }
                                                            >
                                                                <div className="img-menubar">
                                                                    <img
                                                                        src={
                                                                            merchant?.themes
                                                                                ?.bottomBarMenu
                                                                                ?.profileMenu
                                                                                ?.iconBottomName
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </StyleImgVector>
                                                        ) : null}
                                                        <span>
                                                            {merchant?.themes?.bottomBarMenu
                                                                ?.profileMenu?.bottomTitleTh ||
                                                                "โปรไฟล์"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </StyledMenuBarType3>
                            ) : null}
                        </>
                    ) : (
                        <>
                            {merchant?.themes?.sellerThemeSetting?.bottomBarMenu?.menuType
                                ?.isType1 ? (
                                <StyledMenuBar themeColor={themes?.themeColor!}>
                                    <div className="sub-bg"></div>
                                    <div className="main-menubar">
                                        {i18nextLng === enumLanguage.EN ||
                                        i18nextLng === enumLanguage.EN_GB ? (
                                            <>
                                                <div className="control-menubar">
                                                    <div
                                                        className="box-menubar"
                                                        onClick={() => history.push(PATH_HOME)}
                                                    >
                                                        {merchant?.themes?.sellerThemeSetting
                                                            ?.bottomBarMenu?.iconType.isImage ? (
                                                            <div className="img-menubar">
                                                                <img
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.sellerThemeSetting
                                                                            ?.bottomBarMenu
                                                                            ?.homeMenu
                                                                            ?.iconBottomName
                                                                    }
                                                                    alt=""
                                                                />
                                                            </div>
                                                        ) : null}
                                                        {merchant?.themes?.sellerThemeSetting
                                                            ?.bottomBarMenu?.iconType.isVector ? (
                                                            <StyleImgVector
                                                                color={
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.normalColor
                                                                }
                                                            >
                                                                <div className="img-menubar">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.bottomBarMenu
                                                                                ?.homeMenu
                                                                                ?.iconBottomName
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </StyleImgVector>
                                                        ) : null}
                                                        <span>
                                                            {merchant?.themes?.sellerThemeSetting
                                                                ?.bottomBarMenu?.homeMenu
                                                                ?.bottomName || "Home"}
                                                        </span>
                                                    </div>
                                                    {merchant?.themes?.sellerThemeSetting?.bottomBarMenu?.bottomBarName.map(
                                                        (item: any, index: any) => {
                                                            if (!item?.isUse) {
                                                                return null;
                                                            }
                                                            return (
                                                                <div
                                                                    className="box-menubar"
                                                                    key={index}
                                                                    onClick={() =>
                                                                        handleClickBottomMenu(
                                                                            item.bottomLink
                                                                        )
                                                                    }
                                                                >
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.iconType
                                                                        .isImage ? (
                                                                        <div className="img-menubar">
                                                                            <img
                                                                                src={
                                                                                    item.iconBottomName
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    ) : null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.iconType
                                                                        .isVector ? (
                                                                        <StyleImgVector
                                                                            color={
                                                                                merchant?.themes
                                                                                    ?.sellerThemeSetting
                                                                                    ?.bottomBarMenu
                                                                                    ?.normalColor
                                                                            }
                                                                        >
                                                                            <div className="img-menubar">
                                                                                <img
                                                                                    src={
                                                                                        item.iconBottomName
                                                                                    }
                                                                                    alt=""
                                                                                />
                                                                            </div>
                                                                        </StyleImgVector>
                                                                    ) : null}
                                                                    <span>
                                                                        {item.bottomTitle || "Menu"}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                    <div
                                                        className="box-menubar"
                                                        onClick={() => history.push(PATH_PROFILE)}
                                                    >
                                                        <div className="img-menubar">
                                                            <img
                                                                src={
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.profileMenu
                                                                        ?.iconBottomName
                                                                }
                                                                alt=""
                                                            />
                                                        </div>
                                                        <span>
                                                            {merchant?.themes?.sellerThemeSetting
                                                                ?.bottomBarMenu?.profileMenu
                                                                ?.bottomName || "Profile"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="control-menubar">
                                                    <div
                                                        className="box-menubar"
                                                        onClick={() => history.push(PATH_HOME)}
                                                    >
                                                        {merchant?.themes?.sellerThemeSetting
                                                            ?.bottomBarMenu?.iconType.isImage ? (
                                                            <div className="img-menubar">
                                                                <img
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.sellerThemeSetting
                                                                            ?.bottomBarMenu
                                                                            ?.homeMenu
                                                                            ?.iconBottomName
                                                                    }
                                                                    alt=""
                                                                />
                                                            </div>
                                                        ) : null}
                                                        {merchant?.themes?.sellerThemeSetting
                                                            ?.bottomBarMenu?.iconType.isVector ? (
                                                            <StyleImgVector
                                                                color={
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.normalColor
                                                                }
                                                            >
                                                                <div className="img-menubar">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.bottomBarMenu
                                                                                ?.homeMenu
                                                                                ?.iconBottomName
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </StyleImgVector>
                                                        ) : null}
                                                        <span>
                                                            {merchant?.themes?.sellerThemeSetting
                                                                ?.bottomBarMenu?.homeMenu
                                                                ?.bottomName || "หน้าแรก"}
                                                        </span>
                                                    </div>
                                                    {merchant?.themes?.sellerThemeSetting?.bottomBarMenu?.bottomBarName.map(
                                                        (item: any, index: any) => {
                                                            if (!item?.isUse) {
                                                                return null;
                                                            }
                                                            return (
                                                                <div
                                                                    className="box-menubar"
                                                                    key={index}
                                                                    onClick={() =>
                                                                        handleClickBottomMenu(
                                                                            item.bottomLink
                                                                        )
                                                                    }
                                                                >
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.iconType
                                                                        .isImage ? (
                                                                        <div className="img-menubar">
                                                                            <img
                                                                                src={
                                                                                    item.iconBottomName
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    ) : null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.iconType
                                                                        .isVector ? (
                                                                        <StyleImgVector
                                                                            color={
                                                                                merchant?.themes
                                                                                    ?.sellerThemeSetting
                                                                                    ?.bottomBarMenu
                                                                                    ?.normalColor
                                                                            }
                                                                        >
                                                                            <div className="img-menubar">
                                                                                <img
                                                                                    src={
                                                                                        item.iconBottomName
                                                                                    }
                                                                                    alt=""
                                                                                />
                                                                            </div>
                                                                        </StyleImgVector>
                                                                    ) : null}
                                                                    <span>
                                                                        {item.bottomTitleTh ||
                                                                            "เมนู"}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                    <div
                                                        className="box-menubar"
                                                        onClick={() => history.push(PATH_PROFILE)}
                                                    >
                                                        {merchant?.themes?.sellerThemeSetting
                                                            ?.bottomBarMenu?.iconType.isImage ? (
                                                            <div className="img-menubar">
                                                                <img
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.sellerThemeSetting
                                                                            ?.bottomBarMenu
                                                                            ?.profileMenu
                                                                            ?.iconBottomName
                                                                    }
                                                                    alt=""
                                                                />
                                                            </div>
                                                        ) : null}
                                                        {merchant?.themes?.sellerThemeSetting
                                                            ?.bottomBarMenu?.iconType.isVector ? (
                                                            <StyleImgVector
                                                                color={
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.normalColor
                                                                }
                                                            >
                                                                <div className="img-menubar">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.bottomBarMenu
                                                                                ?.profileMenu
                                                                                ?.iconBottomName
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </StyleImgVector>
                                                        ) : null}
                                                        <span>
                                                            {merchant?.themes?.sellerThemeSetting
                                                                ?.bottomBarMenu?.profileMenu
                                                                ?.bottomName || "โปรไฟล์"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </StyledMenuBar>
                            ) : null}
                            {merchant?.themes?.sellerThemeSetting?.bottomBarMenu?.menuType
                                ?.isType2 ? (
                                <StyledMenuBarType2
                                    themeColor={themes?.themeColor!}
                                    color={
                                        merchant?.themes?.sellerThemeSetting?.bottomBarMenu
                                            ?.normalColor
                                    }
                                >
                                    <StyledSubMenu
                                        color={
                                            merchant?.themes?.sellerThemeSetting?.bottomBarMenu
                                                ?.clickColor
                                        }
                                    >
                                        <div className="sub-bg"></div>
                                        <div className="main-menubar">
                                            {i18nextLng === enumLanguage.EN ||
                                            i18nextLng === enumLanguage.EN_GB ? (
                                                <>
                                                    <div className="control-menubar">
                                                        <StyledImgType2
                                                            img={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.homeMenu?.iconBottomName!
                                                            }
                                                            clickicon={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.homeMenu
                                                                    ?.iconClickStateBottomName!
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    "box-menubar " +
                                                                    (pathname === PATH_HOME
                                                                        ? "active"
                                                                        : "")
                                                                }
                                                                onClick={() =>
                                                                    history.push(PATH_HOME)
                                                                }
                                                            >
                                                                {merchant?.themes
                                                                    ?.sellerThemeSetting
                                                                    ?.bottomBarMenu?.iconType
                                                                    .isImage ? (
                                                                    <div
                                                                        className={"showimgtype2"}
                                                                    ></div>
                                                                ) : null}
                                                                {merchant?.themes
                                                                    ?.sellerThemeSetting
                                                                    ?.bottomBarMenu?.iconType
                                                                    .isVector ? (
                                                                    <StyleImgVector
                                                                        color={
                                                                            merchant?.themes
                                                                                ?.normalColor
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={
                                                                                "showimgtype2"
                                                                            }
                                                                        ></div>
                                                                    </StyleImgVector>
                                                                ) : null}
                                                                <span>
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.homeMenu
                                                                        ?.bottomName || "Home"}
                                                                </span>
                                                            </div>
                                                        </StyledImgType2>
                                                        {merchant?.themes?.sellerThemeSetting?.bottomBarMenu?.bottomBarName.map(
                                                            (item: any, index: any) => {
                                                                if (!item?.isUse) {
                                                                    return null;
                                                                }
                                                                return (
                                                                    <StyledImgType2
                                                                        img={item.iconBottomName}
                                                                        clickicon={
                                                                            item.iconClickStateBottomName
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={
                                                                                "box-menubar " +
                                                                                (pathname ===
                                                                                item.bottomLink
                                                                                    ? "active"
                                                                                    : "")
                                                                            }
                                                                            key={index}
                                                                            onClick={() =>
                                                                                handleClickBottomMenu(
                                                                                    item.bottomLink
                                                                                )
                                                                            }
                                                                        >
                                                                            {merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.bottomBarMenu
                                                                                ?.iconType
                                                                                .isImage ? (
                                                                                <div
                                                                                    className={
                                                                                        "showimgtype2"
                                                                                    }
                                                                                ></div>
                                                                            ) : null}
                                                                            {merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.bottomBarMenu
                                                                                ?.iconType
                                                                                .isVector ? (
                                                                                <StyleImgVector
                                                                                    color={
                                                                                        merchant
                                                                                            .themes
                                                                                            ?.sellerThemeSetting
                                                                                            ?.bottomBarMenu
                                                                                            ?.normalColor
                                                                                    }
                                                                                >
                                                                                    <div
                                                                                        className={
                                                                                            "showimgtype2"
                                                                                        }
                                                                                    ></div>
                                                                                </StyleImgVector>
                                                                            ) : null}
                                                                            <span>
                                                                                {item.bottomTitle ||
                                                                                    "Menu"}
                                                                            </span>
                                                                        </div>
                                                                    </StyledImgType2>
                                                                );
                                                            }
                                                        )}
                                                        <StyledImgType2
                                                            img={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.profileMenu?.iconBottomName!
                                                            }
                                                            clickicon={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.profileMenu
                                                                    ?.iconClickStateBottomName!
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    "box-menubar " +
                                                                    (pathname === PATH_PROFILE
                                                                        ? "active"
                                                                        : "")
                                                                }
                                                                onClick={() =>
                                                                    history.push(PATH_PROFILE)
                                                                }
                                                            >
                                                                <div
                                                                    className={"showimgtype2"}
                                                                ></div>
                                                                <span>
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.profileMenu
                                                                        ?.bottomName || "Profile"}
                                                                </span>
                                                            </div>
                                                        </StyledImgType2>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="control-menubar">
                                                        <StyledImgType2
                                                            img={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.homeMenu?.iconBottomName!
                                                            }
                                                            clickicon={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.homeMenu
                                                                    ?.iconClickStateBottomName!
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    "box-menubar " +
                                                                    (pathname === PATH_HOME
                                                                        ? "active"
                                                                        : "")
                                                                }
                                                                onClick={() =>
                                                                    history.push(PATH_HOME)
                                                                }
                                                            >
                                                                {merchant?.themes
                                                                    ?.sellerThemeSetting
                                                                    ?.bottomBarMenu?.iconType
                                                                    .isImage ? (
                                                                    <div
                                                                        className={"showimgtype2"}
                                                                    ></div>
                                                                ) : null}
                                                                {merchant?.themes
                                                                    ?.sellerThemeSetting
                                                                    ?.bottomBarMenu?.iconType
                                                                    .isVector ? (
                                                                    <StyleImgVector
                                                                        color={
                                                                            merchant?.themes
                                                                                ?.normalColor
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={
                                                                                "showimgtype2"
                                                                            }
                                                                        ></div>
                                                                    </StyleImgVector>
                                                                ) : null}
                                                                <span>
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.homeMenu
                                                                        ?.bottomName || "หน้าแรก"}
                                                                </span>
                                                            </div>
                                                        </StyledImgType2>
                                                        {merchant?.themes?.sellerThemeSetting?.bottomBarMenu?.bottomBarName.map(
                                                            (item: any, index: any) => {
                                                                if (!item?.isUse) {
                                                                    return null;
                                                                }
                                                                return (
                                                                    <StyledImgType2
                                                                        img={item.iconBottomName}
                                                                        clickicon={
                                                                            item.iconClickStateBottomName
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={
                                                                                "box-menubar " +
                                                                                (pathname ===
                                                                                item.bottomLink
                                                                                    ? "active"
                                                                                    : "")
                                                                            }
                                                                            key={index}
                                                                            onClick={() =>
                                                                                handleClickBottomMenu(
                                                                                    item.bottomLink
                                                                                )
                                                                            }
                                                                        >
                                                                            {merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.bottomBarMenu
                                                                                ?.iconType
                                                                                .isImage ? (
                                                                                <div
                                                                                    className={
                                                                                        "showimgtype2"
                                                                                    }
                                                                                ></div>
                                                                            ) : null}
                                                                            {merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.bottomBarMenu
                                                                                ?.iconType
                                                                                .isVector ? (
                                                                                <StyleImgVector
                                                                                    color={
                                                                                        merchant
                                                                                            .themes
                                                                                            ?.sellerThemeSetting
                                                                                            ?.bottomBarMenu
                                                                                            ?.normalColor
                                                                                    }
                                                                                >
                                                                                    <div
                                                                                        className={
                                                                                            "showimgtype2"
                                                                                        }
                                                                                    ></div>
                                                                                </StyleImgVector>
                                                                            ) : null}
                                                                            <span>
                                                                                {item.bottomTitleTh ||
                                                                                    "เมนู"}
                                                                            </span>
                                                                        </div>
                                                                    </StyledImgType2>
                                                                );
                                                            }
                                                        )}
                                                        <StyledImgType2
                                                            img={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.profileMenu?.iconBottomName!
                                                            }
                                                            clickicon={
                                                                merchant?.themes?.bottomBarMenu
                                                                    ?.profileMenu
                                                                    ?.iconClickStateBottomName!
                                                            }
                                                        >
                                                            <div
                                                                className="box-menubar"
                                                                onClick={() =>
                                                                    history.push(PATH_PROFILE)
                                                                }
                                                            >
                                                                {merchant?.themes
                                                                    ?.sellerThemeSetting
                                                                    ?.bottomBarMenu?.iconType
                                                                    .isImage ? (
                                                                    <div
                                                                        className={"showimgtype2"}
                                                                    ></div>
                                                                ) : null}
                                                                {merchant?.themes
                                                                    ?.sellerThemeSetting
                                                                    ?.bottomBarMenu?.iconType
                                                                    .isVector ? (
                                                                    <StyleImgVector
                                                                        color={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.bottomBarMenu
                                                                                ?.normalColor
                                                                        }
                                                                    >
                                                                        <div
                                                                            className={
                                                                                "showimgtype2"
                                                                            }
                                                                        ></div>
                                                                    </StyleImgVector>
                                                                ) : null}
                                                                <span>
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.profileMenu
                                                                        ?.bottomName || "โปรไฟล์"}
                                                                </span>
                                                            </div>
                                                        </StyledImgType2>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </StyledSubMenu>
                                </StyledMenuBarType2>
                            ) : null}
                            {merchant?.themes?.sellerThemeSetting?.bottomBarMenu?.menuType
                                ?.isType3 ? (
                                <StyledMenuBarType3 themeColor={themes?.themeColor!}>
                                    <div className="sub-bg"></div>
                                    <div className="main-menubar">
                                        {i18nextLng === enumLanguage.EN ||
                                        i18nextLng === enumLanguage.EN_GB ? (
                                            <>
                                                <div className="control-menubar type3">
                                                    <div
                                                        className={
                                                            "box-menubar " +
                                                            (pathname === PATH_HOME ? "active" : "")
                                                        }
                                                        onClick={() => history.push(PATH_HOME)}
                                                    >
                                                        {merchant?.themes?.sellerThemeSetting
                                                            ?.bottomBarMenu?.iconType.isImage ? (
                                                            <div className="img-menubar">
                                                                <img
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.sellerThemeSetting
                                                                            ?.bottomBarMenu
                                                                            ?.homeMenu
                                                                            ?.iconBottomName
                                                                    }
                                                                    alt=""
                                                                />
                                                            </div>
                                                        ) : null}
                                                        {merchant?.themes?.sellerThemeSetting
                                                            ?.bottomBarMenu?.iconType.isVector ? (
                                                            <StyleImgVector
                                                                color={
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.normalColor
                                                                }
                                                            >
                                                                <div className="img-menubar">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.bottomBarMenu
                                                                                ?.homeMenu
                                                                                ?.iconBottomName
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </StyleImgVector>
                                                        ) : null}
                                                        <span>
                                                            {merchant?.themes?.sellerThemeSetting
                                                                ?.bottomBarMenu?.homeMenu
                                                                ?.bottomName || "Home"}
                                                        </span>
                                                    </div>
                                                    {merchant?.themes?.sellerThemeSetting?.bottomBarMenu?.bottomBarName.map(
                                                        (item: any, index: any) => {
                                                            if (!item?.isUse) {
                                                                return null;
                                                            }
                                                            return (
                                                                <div
                                                                    className={
                                                                        "box-menubar " +
                                                                        (pathname ===
                                                                        item.bottomLink
                                                                            ? "active"
                                                                            : "")
                                                                    }
                                                                    key={index}
                                                                    onClick={() =>
                                                                        handleClickBottomMenu(
                                                                            item.bottomLink
                                                                        )
                                                                    }
                                                                >
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.iconType
                                                                        .isImage ? (
                                                                        <div className="img-menubar">
                                                                            <img
                                                                                src={
                                                                                    item.iconBottomName
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    ) : null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.iconType
                                                                        .isVector ? (
                                                                        <StyleImgVector
                                                                            color={
                                                                                merchant?.themes
                                                                                    ?.normalColor
                                                                            }
                                                                        >
                                                                            <div className="img-menubar">
                                                                                <img
                                                                                    src={
                                                                                        item.iconBottomName
                                                                                    }
                                                                                    alt=""
                                                                                />
                                                                            </div>
                                                                        </StyleImgVector>
                                                                    ) : null}
                                                                    <span>
                                                                        {item.bottomTitle || "Menu"}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                    <div
                                                        className={
                                                            "box-menubar " +
                                                            (pathname === PATH_PROFILE
                                                                ? "active"
                                                                : "")
                                                        }
                                                        onClick={() => history.push(PATH_PROFILE)}
                                                    >
                                                        <div className="img-menubar">
                                                            <img
                                                                src={
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.profileMenu
                                                                        ?.iconBottomName
                                                                }
                                                                alt=""
                                                            />
                                                        </div>
                                                        <span>
                                                            {merchant?.themes?.sellerThemeSetting
                                                                ?.bottomBarMenu?.profileMenu
                                                                ?.bottomName || "Profile"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="control-menubar type3">
                                                    <div
                                                        className={
                                                            "box-menubar " +
                                                            (pathname === PATH_HOME ? "active" : "")
                                                        }
                                                        onClick={() => history.push(PATH_HOME)}
                                                    >
                                                        {merchant?.themes?.sellerThemeSetting
                                                            ?.bottomBarMenu?.iconType.isImage ? (
                                                            <div className="img-menubar">
                                                                <img
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.sellerThemeSetting
                                                                            ?.bottomBarMenu
                                                                            ?.homeMenu
                                                                            ?.iconBottomName
                                                                    }
                                                                    alt=""
                                                                />
                                                            </div>
                                                        ) : null}
                                                        {merchant?.themes?.sellerThemeSetting
                                                            ?.bottomBarMenu?.iconType.isVector ? (
                                                            <StyleImgVector
                                                                color={
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.normalColor
                                                                }
                                                            >
                                                                <div className="img-menubar">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.bottomBarMenu
                                                                                ?.homeMenu
                                                                                ?.iconBottomName
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </StyleImgVector>
                                                        ) : null}
                                                        <span>
                                                            {merchant?.themes?.sellerThemeSetting
                                                                ?.bottomBarMenu?.homeMenu
                                                                ?.bottomName || "หน้าแรก"}
                                                        </span>
                                                    </div>
                                                    {merchant?.themes?.sellerThemeSetting?.bottomBarMenu?.bottomBarName.map(
                                                        (item: any, index: any) => {
                                                            if (!item?.isUse) {
                                                                return null;
                                                            }
                                                            return (
                                                                <div
                                                                    className={
                                                                        "box-menubar " +
                                                                        (pathname ===
                                                                        item.bottomLink
                                                                            ? "active"
                                                                            : "")
                                                                    }
                                                                    key={index}
                                                                    onClick={() =>
                                                                        handleClickBottomMenu(
                                                                            item.bottomLink
                                                                        )
                                                                    }
                                                                >
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.iconType
                                                                        .isImage ? (
                                                                        <div className="img-menubar">
                                                                            <img
                                                                                src={
                                                                                    item.iconBottomName
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    ) : null}
                                                                    {merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.iconType
                                                                        .isVector ? (
                                                                        <StyleImgVector
                                                                            color={
                                                                                merchant?.themes
                                                                                    ?.sellerThemeSetting
                                                                                    ?.bottomBarMenu
                                                                                    ?.normalColor
                                                                            }
                                                                        >
                                                                            <div className="img-menubar">
                                                                                <img
                                                                                    src={
                                                                                        item.iconBottomName
                                                                                    }
                                                                                    alt=""
                                                                                />
                                                                            </div>
                                                                        </StyleImgVector>
                                                                    ) : null}
                                                                    <span>
                                                                        {item.bottomTitleTh ||
                                                                            "เมนู"}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                    <div
                                                        className={
                                                            "box-menubar " +
                                                            (pathname === PATH_PROFILE
                                                                ? "active"
                                                                : "")
                                                        }
                                                        onClick={() => history.push(PATH_PROFILE)}
                                                    >
                                                        {merchant?.themes?.sellerThemeSetting
                                                            ?.bottomBarMenu?.iconType.isImage ? (
                                                            <div className="img-menubar">
                                                                <img
                                                                    src={
                                                                        merchant?.themes
                                                                            ?.sellerThemeSetting
                                                                            ?.bottomBarMenu
                                                                            ?.profileMenu
                                                                            ?.iconBottomName
                                                                    }
                                                                    alt=""
                                                                />
                                                            </div>
                                                        ) : null}
                                                        {merchant?.themes?.sellerThemeSetting
                                                            ?.bottomBarMenu?.iconType.isVector ? (
                                                            <StyleImgVector
                                                                color={
                                                                    merchant?.themes
                                                                        ?.sellerThemeSetting
                                                                        ?.bottomBarMenu?.normalColor
                                                                }
                                                            >
                                                                <div className="img-menubar">
                                                                    <img
                                                                        src={
                                                                            merchant.themes
                                                                                ?.sellerThemeSetting
                                                                                ?.bottomBarMenu
                                                                                ?.profileMenu
                                                                                ?.iconBottomName
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </StyleImgVector>
                                                        ) : null}
                                                        <span>
                                                            {merchant?.themes?.sellerThemeSetting
                                                                ?.bottomBarMenu?.profileMenu
                                                                ?.bottomName || "โปรไฟล์"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </StyledMenuBarType3>
                            ) : null}
                        </>
                    )}
                </>
            ) : (
                loadingComponent
            )}
        </>
    );
};
const StyledSkeleton = styled.div`
    position: fixed;
    bottom: 0;
    left: 50%;
    z-index: 1;
    width: 100%;
    max-width: 480px;
    transform: translateX(-50%);
    overflow: hidden;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
    padding: 10px 16px;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    background-color: #fff;
    .wrapper-skeleton {
        .layout-skeleton {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            .ant-skeleton {
                display: flex;
                flex-direction: column;
                padding: 5px 0;
                background-color: #fff;
                .ant-skeleton-avatar {
                    width: 24px;
                    height: 24px;
                }
                .ant-skeleton-header {
                    padding-right: 0;
                    margin: 0 auto;
                    margin-bottom: 5px;
                }
                .ant-skeleton-paragraph {
                    margin-bottom: 0;
                    li {
                        margin: 0 auto;
                        height: 7px;
                        border-radius: 16px;
                    }
                }
            }
        }
    }
`;
const StyledImgType2 = styled.div<{ img: string; clickicon: string }>`
    .showimgtype2 {
        background-image: url(${(props) => props.img});
        background-size: contain;
        width: 24px;
        height: 24px;
        background-repeat: no-repeat;
        margin: 0 auto;
        background-position: center;
    }
    .box-menubar.active {
        .showimgtype2 {
            background-image: url(${(props) => props.clickicon});
        }
    }
`;
const StyledSubMenu = styled.div`
    .main-menubar {
        .control-menubar {
            .box-menubar {
                &:hover {
                    .img-menubar {
                        img {
                            filter: inherit;
                        }
                        .filtermenu {
                            background-color: ${(props) => props.color}!important;
                        }
                    }
                    span {
                        color: ${(props) => props.color}!important;
                    }
                }
            }
        }
    }
`;
const TextFilterMenu = styled.span`
    &:hover {
        color: ${(props) => props.color}!important;
    }
`;

const StyleImgVector = styled.div`
    .img-menubar {
        background-color: ${(props) => props.color};
    }
`;
const StyledMenuBar = styled.div<{ themeColor: string }>`
    position: fixed;
    bottom: 0;
    left: 50%;
    z-index: 1;
    width: 100%;
    max-width: 480px;
    transform: translateX(-50%);
    /* background-color: pink; */
    overflow: hidden;
    .sub-bg {
        z-index: -1;
        content: "";
        width: 114%;
        height: 100px;
        border-radius: 58%;
        background-color: ${(p) => p.themeColor};
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
        position: relative;
        left: 50%;
        top: 60px;
        transform: translateX(-50%);
    }
    .main-menubar {
        width: 100%;
        height: 60px;
        background-color: ${(p) => p.themeColor};
        // box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
        padding: 10px 36px;
        border-top-right-radius: 0;
        border-top-left-radius: 0;
        position: relative;
        z-index: 2;
        // &:after {
        //     z-index: -1;
        //     content: '';
        //     width: 100%;
        //     height: 100px;
        //     border-radius: 58%;
        //     background-color: ${(p) => p.themeColor};
        //     position: absolute;
        //     top: -45px;
        //     left: 50%;
        //     transform: translateX(-50%);
        // }
        .control-menubar {
            position: relative;
            top: -20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .box-qr-menubar {
                margin-top: -50px;
                border-radius: 100%;
                box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
                border: 2px solid #fff;
                .img-menubar {
                    background-color: #336c51;
                    text-align: center;
                    border-radius: 100%;
                    width: 60px;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img {
                        width: 32px;
                        height: 32px;
                    }
                }
            }
            .box-menubar {
                text-align: center;
                .img-menubar {
                    margin-bottom: 5px;
                    img {
                        width: 24px;
                    }
                }
                span {
                    font-size: 13px;
                    line-height: 13px;
                    color: #fff;
                }
            }
        }
    }

    .sub-menubar {
        width: 100%;
        height: 20px;
        background-color: #fff;
        position: relative;
        &:after {
            content: "";
            position: absolute;
            width: 136px;
            height: 5px;
            background-color: #000000;
            top: 8px;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 10px;
        }
    }
`;
const StyledMenuBarType2 = styled.div<{ themeColor: string }>`
    position: fixed;
    bottom: 0;
    left: 50%;
    z-index: 1;
    width: 100%;
    max-width: 480px;
    transform: translateX(-50%);
    overflow: hidden;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
    padding: 10px 16px;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    background-color: #fff;
    .main-menubar {
        width: 100%;
        // height: 60px;
        // background-color: ${(p) => p.themeColor};
        background-color: #fff;
        // box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
        // padding: 10px 36px;
        position: relative;
        z-index: 2;
        // &:after {
        //     z-index: -1;
        //     content: '';
        //     width: 100%;
        //     height: 100px;
        //     border-radius: 58%;
        //     background-color: ${(p) => p.themeColor};
        //     position: absolute;
        //     top: -45px;
        //     left: 50%;
        //     transform: translateX(-50%);
        // }
        .control-menubar {
            position: relative;
            // top: -20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .box-qr-menubar {
                margin-top: -50px;
                border-radius: 100%;
                box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
                border: 2px solid #fff;
                .img-menubar {
                    background-color: #336c51;
                    text-align: center;
                    border-radius: 100%;
                    width: 60px;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img {
                        width: 32px;
                        height: 32px;
                        fill: #ff0000;
                    }
                    path {
                        fill: #ff0000;
                    }
                }
            }
            .box-menubar.active {
                span {
                    color: ${(props) => props.color};
                }
            }
            .box-menubar {
                text-align: center;
                .img-menubar {
                    margin-bottom: 5px;
                    img {
                        width: 24px;
                    }
                    .filtermenu {
                        mask-size: 100%;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        mask-position: center;
                    }
                }
                span {
                    font-size: 13px;
                    line-height: 13px;
                    color: #000;
                    // color: ${(props) => props.color};
                    @media (max-width: 400px) {
                        font-size: 10px;
                    }
                }
                &:hover {
                    .img-menubar {
                        img {
                            filter: inherit;
                        }
                    }
                    span {
                        color: ${(props) => props.color};
                    }
                }
            }
        }
    }

    .sub-menubar {
        width: 100%;
        height: 20px;
        background-color: #fff;
        position: relative;
        &:after {
            content: "";
            position: absolute;
            width: 136px;
            height: 5px;
            background-color: #000000;
            top: 8px;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 10px;
        }
    }
`;
const StyledMenuBarType3 = styled.div<{ themeColor: string }>`
    position: fixed;
    bottom: -1px;
    left: 50%;
    z-index: 1;
    width: 100%;
    max-width: 480px;
    transform: translateX(-50%);
    .main-menubar {
        width: 100%;
        background-color: ${(p) => p.themeColor};
        // box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
        padding: 0 36px;
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;
        position: relative;
        z-index: 2;
        height: 55px;
        // &:after {
        //     z-index: -1;
        //     content: '';
        //     width: 100%;
        //     height: 100px;
        //     border-radius: 58%;
        //     background-color: ${(p) => p.themeColor};
        //     position: absolute;
        //     top: -45px;
        //     left: 50%;
        //     transform: translateX(-50%);
        // }
        .type3 {
            justify-content: center !important;
            .box-menubar {
                text-align: center;
                padding: 10px;
                margin-top: -35px !important;
                .img-menubar {
                    margin-bottom: 5px;
                    img {
                        width: 45px !important;
                    }
                }
            }
        }
        .control-menubar {
            position: relative;
            // top: -20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: unset;
            .box-qr-menubar {
                margin-top: -50px;
                border-radius: 100%;
                box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
                border: 2px solid #fff;
                .img-menubar {
                    background-color: #336c51;
                    text-align: center;
                    border-radius: 100%;
                    width: 60px;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img {
                        width: 32px;
                        height: 32px;
                    }
                }
            }
            .box-menubar {
                text-align: center;
                padding: 10px;
                margin-top: -30px;
                position: reletive;
                .img-menubar {
                    margin-bottom: 5px;
                    position: relative;
                    z-index: 1;
                    img {
                        width: 24px;
                    }
                }
                span {
                    font-size: 13px;
                    line-height: 13px;
                    color: #fff;
                    position: relative;
                    z-index: 1;
                    white-space: nowrap;
                }
            }
            .box-menubar.active {
                position: relative;
                &:after {
                    content: "";
                    width: 100%;
                    height: 55px;
                    position: absolute;
                    left: 0;
                    bottom: -2px;
                    background: rgb(0, 0, 0);
                    background: linear-gradient(
                        0deg,
                        rgba(0, 0, 0, 0.7) 0%,
                        rgba(0, 0, 0, 0.2) 100%
                    );
                }
            }
        }
    }

    .sub-menubar {
        width: 100%;
        height: 20px;
        background-color: #fff;
        position: relative;
        &:after {
            content: "";
            position: absolute;
            width: 136px;
            height: 5px;
            background-color: #000000;
            top: 8px;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 10px;
        }
    }
`;
